import React from 'react';
import ReactDOM from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
//import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {Provider} from 'react-redux';
import './ui/sass/normalize-5.0.0.scss';
import './ui/sass/main.scss';
import store from './model/reducers/store'

import Routes from './routes'
import {UIConstants } from "./model/constants/uiConstants";

const muiTheme = getMuiTheme({
    palette: {
        primary1Color: UIConstants.LOOKLET_COLOR_1,
    },
});
// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();
//muiTheme={getMuiTheme(darkBaseTheme)}
ReactDOM.render(

    <MuiThemeProvider muiTheme={muiTheme}>
        <Provider store={store}>
            <Routes />
        </Provider>
    </MuiThemeProvider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js